import gql from 'graphql-tag';

export const COMMENT_FRAGMENT = gql`
fragment CommentFragment on Comment {
  body
  id
  insertedAt
  parentCommentId
  user {
    id
    username
    insertedAt
    roleId
    badge
    avatar {
      thumb
    }
  }
  comments {
    id
    body
    insertedAt
    user {
      id
      username
      insertedAt
      roleId
      avatar {
        thumb
      }
    }
  }
}`;

export const COMMENT_QUERY = gql`
${COMMENT_FRAGMENT}
query comments($wpPostId: NexusId!, $originalSite: String) {
  comments(wpPostId: $wpPostId, originalSite: $originalSite) {
    ...CommentFragment
    comments {
      ...CommentFragment
      comments {
        ...CommentFragment
      }
    }
  }
}
`;
